export default "__VITE_ASSET__C1CY4thI__"